<template>
  <section>
    <base-card>
      <h2>Page not found</h2>
      <p>
        This page could not be found - maybe you want the 
        <router-link to="/">Home Page</router-link>?.
      </p>
    </base-card>
  </section>
</template>